jQuery(document).ready(function ($) {
  $('#login-form').on('submit', () => {
    const submit = $('#login-form').find(':submit');
    submit.attr('disabled', true);
    submit.css({ cursor: 'not-alowed' });
  });
});